import type { InitialPlanningTaskInput } from '@amore/shared'

export const initialPlanningTasks = [
  {
    title: 'Doplnit termín svatby',
    automaticCompletionRule: 'wedding-date-set',
    linkedSection: 'wedding-identity',
    notes:
      'Vybrat datum svatby, případně si nejprve určit preferované období. Zvážit, zda je termín pevný, nebo se může přizpůsobit dostupnosti místa.',
    priority: 'high',
    labelNames: ['Místo', 'Obřad'],
  },
  {
    title: 'Stanovit rámcový rozpočet',
    automaticCompletionRule: 'budget-total-set',
    linkedSection: 'budget',
    notes:
      'Domluvit celkovou částku na svatbu a zapsat ji do rozpočtu. Pro začátek stačí orientační limit, který pomůže při výběru místa a dodavatelů.',
    priority: 'high',
    labelNames: ['Rozpočet'],
  },
  {
    title: 'Připravit první seznam hostů',
    linkedSection: 'guests',
    notes:
      'Přidat nejbližší rodinu a přátele a odhadnout celkový počet hostů. Promyslet také účast dětí a doprovodů, aby bylo možné hledat místo s odpovídající kapacitou.',
    priority: 'high',
    labelNames: ['Hosté'],
  },
  {
    title: 'Ujasnit místo konání svatby',
    notes:
      'Rozhodnout, zda se obřad a hostina uskuteční na jednom místě. Přidat již domluvené místo, nebo zaznamenat představu a začít vybírat vhodné možnosti.',
    priority: 'high',
    labelNames: ['Místo'],
  },
  {
    title: 'Rozhodnout o podobě obřadu',
    notes:
      'Vybrat civilní, církevní nebo symbolický obřad a určit jeho předpokládané místo. Zaznamenat, zda je již domluvený oddávající a co ještě zbývá vyřešit.',
    priority: 'high',
    labelNames: ['Obřad'],
  },
  {
    title: 'Rozhodnout, kdo zajistí jídlo a pití',
    notes:
      'Ujasnit, zda občerstvení zajistí místo konání, externí catering nebo více dodavatelů. Promyslet podobu hostiny, nápoje a dort, aby bylo jasné, které služby je potřeba domluvit.',
    priority: 'normal',
    labelNames: ['Hostina', 'Dodavatelé'],
  },
  {
    title: 'Rozhodnout o focení a videu',
    notes:
      'Ujasnit, zda je zájem o fotografa, kameramana a předsvatební focení. Doplnit již vybrané dodavatele nebo začít hledat podle požadovaného rozsahu a rozpočtu.',
    priority: 'normal',
    labelNames: ['Dodavatelé'],
  },
  {
    title: 'Vybrat podobu hudby a zábavy',
    notes:
      'Rozhodnout o hudbě při obřadu a na oslavě — například mezi živou hudbou, DJ a vlastními nahrávkami. Promyslet také moderování a případný doprovodný program.',
    priority: 'normal',
    labelNames: ['Obřad', 'Hostina', 'Dodavatelé'],
  },
  {
    title: 'Naplánovat líčení a účes',
    notes:
      'Ujasnit, kdo zajistí líčení a účes a zda budou služby potřeba i pro další osoby. Doplnit domluvené kontakty nebo začít s výběrem; následně naplánovat zkoušky.',
    priority: 'normal',
    labelNames: ['Dodavatelé'],
  },
  {
    title: 'Ujasnit styl a zajištění výzdoby',
    notes:
      'Zvolit základní styl a barvy svatby. Rozhodnout, co zajistí místo, dodavatelé nebo vlastní příprava, a vybrat potřebné květiny, dekorace a tiskoviny.',
    priority: 'normal',
    labelNames: ['Místo', 'Dodavatelé'],
  },
  {
    title: 'Začít vybírat šaty, oblek a prsteny',
    notes:
      'Zaznamenat, co už je vybrané a co zbývá zajistit. Vybrat salony či dodavatele a naplánovat potřebné návštěvy a zkoušky.',
    priority: 'normal',
    labelNames: ['Dodavatelé'],
  },
  {
    title: 'Připravit informace pro hosty',
    notes:
      'Po potvrzení termínu a místa připravit základní informace o svatbě, příjezdu a potvrzení účasti. Rozhodnout, zda pro jejich sdílení využít svatební web.',
    priority: 'normal',
    labelNames: ['Hosté'],
  },
  {
    title: 'Připravit první návrh harmonogramu',
    notes:
      'Jakmile jsou známé hlavní časy, projít harmonogram a doplnit příjezd hostů, obřad, hostinu a další plánované události. Podrobnosti postupně upřesňovat podle domluv s dodavateli.',
    priority: 'low',
    labelNames: ['Obřad', 'Hostina'],
  },
] satisfies InitialPlanningTaskInput[]
